import React from 'react'
import PropTypes from 'prop-types'
import {
  useFetchOfficeLocations,
  useOfficeLocations,
} from '../../redux/slices/office-locations'
import AsyncSelect from './AsyncSelect'

export default function OfficeLocationSelect({ practiceId, ...props }) {
  const fetchOptions = useFetchOfficeLocations(practiceId)
  const officeLocations = useOfficeLocations(practiceId)

  return (
    <AsyncSelect
      fetchOptions={fetchOptions}
      options={officeLocations}
      showSearch
      allowClear
      optionFilterProp="children"
      placeholder="Select office location"
      {...props}
    />
  )
}

OfficeLocationSelect.propTypes = {
  practiceId: PropTypes.string.isRequired,
}
